import React from 'react';
import { useFormNav } from '../../context';
import { Screen } from '../screen';

export const Flow: React.FC = () => {
  const { currentScreen } = useFormNav();
  return <Screen screenName={currentScreen} />;
};
